import { render, staticRenderFns } from "./SurgeryInsuranceInvoice.vue?vue&type=template&id=07074771&scoped=true"
import script from "./SurgeryInsuranceInvoice.vue?vue&type=script&lang=js"
export * from "./SurgeryInsuranceInvoice.vue?vue&type=script&lang=js"
import style0 from "./SurgeryInsuranceInvoice.vue?vue&type=style&index=0&id=07074771&prod&scoped=true&lang=css"
import style1 from "./SurgeryInsuranceInvoice.vue?vue&type=style&index=1&id=07074771&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07074771",
  null
  
)

export default component.exports